import { IViewService } from '../interface/view-service.interface';
import BaseView from './base-view';
import BaseViewModel from './base-view-model';

/**
 * 负责处理View相关业务逻辑
 */
export default abstract class BaseViewService<P = {}> implements IViewService<P> {
    /**
     * model层，存储和更新ui显示的数据
     * @protected
     */
    protected model: BaseViewModel<P>;
    /**
     * view相关回调，主要service用来触发View的更新
     * @protected
     */
    protected viewDelegate?: BaseView<P>;

    public constructor() {
        this.model = this.createViewModel();
    }

    public getModel(): BaseViewModel<P> {
        return this.model;
    }

    public setViewDelegate(view: BaseView<P>) {
        // view和Service双向绑定
        this.viewDelegate = view;

        this.model.initModel(view.getProps(), this.getInitModelValue());
        this.initWithProps(view.getProps());

        view.bindViewService(this);
    }

    public unBindViewDelegate() {
        this.viewDelegate?.unBindViewService();
        this.viewDelegate = undefined;
    }

    /**
     * 修改model数据并更新UI
     * @param model
     * @param callback
     */
    public updateModel<M extends BaseViewModel<P>>(model: Partial<M>,  callback?: () => void) {
        this.model.applyModel(model);
        this.viewDelegate?.renderView(callback);
    }

    /**
     * Service中获取props
     * @protected
     */
    protected get props(): P | undefined {
        return this.viewDelegate?.getProps();
    }

    protected initWithProps(props?: P) {
        // 子类继承实现
    }

    /**
     * 一部分model的值需要由service来进行初始化
     * @protected
     */
    protected getInitModelValue(): Partial<BaseViewModel<P>> | undefined {
        return undefined;
    }

    /**
     * 创建service对应的ViewModel
     * @protected
     */
    protected abstract createViewModel(): BaseViewModel<P>;
}
